import { Box, Button, Grid, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"
import { contect_Data } from '../Quiz_data/Quiz_data.js';
import { Login } from '../../Components/Login/Login.jsx'
import { Register } from "../../Components/Register/Register.jsx";

export const QuizHome = () => {
    const personal = JSON.parse(localStorage.getItem('personal')) || {};
    const navigate = useNavigate()


    return (
        <Box>

            <Box w={'100%'}>
                {/* navbar */}
                <Box w={['95%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'10px'}>
                    <Box display={'flex'} gap={'7px'}>
                        <Text color={'orange'} fontSize={'25px'} fontWeight={'bold'}>|| Quiz</Text>
                        <Text color={'grey'} fontSize={'25px'} fontWeight={'bold'}>Time</Text>
                    </Box>
                    {personal['token'] ?
                        <Box display={'flex'} gap={'5px'}>
                            <Text color={'orange'} fontWeight={'medium'}>Hi,</Text>
                            <Text>{personal['userName'] && personal['userName'].split(' ')[0]}</Text>
                        </Box> :
                        <Box display={'flex'} gap={'10px'}>
                            <Box cursor={'pointer'} color={'grey'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Login prop={'Quiz_Time'} /></Box>
                            <Box cursor={'pointer'} color={'orange'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Register prop={'Quiz_Time'} /></Box>
                        </Box>
                    }
                </Box>

                {/* banner */}

                <Box w={['100%', '80%']} display={'flex'} flexDirection={['column', 'column', 'row', 'row']} justifyContent={'space-between'} alignItems={'center'} m={['1cm auto', '1cm auto', '1.5cm auto']}>


                    <Box w={['95%', '80%', '50%', '50%']} p={'15px 10px'} borderRadius={'7px'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 4px 10px'}>
                        <Box display={'flex'} gap={'10px'} w={'90%'} m={'10px auto'} fontWeight={'bold'}>
                            <Text fontSize={['14px', '16px', '18px']} color={'#616161'}>1.</Text>
                            <Text fontSize={['14px', '16px', '18px']} color={'orange'} fontWeight={'bold'}>Will You try Quiz Time?</Text>
                        </Box>

                        <Box w={'90%'} m={'10px auto'} fontWeight={'medium'} color={'grey'} border={'1px solid grey'} p={'10px'}>Maybe</Box>
                        <Box w={'90%'} m={'10px auto'} fontWeight={'medium'} border={'1px solid #69F0AE'} p={'10px'} color={'whiteAlpha.900'} bg={'rgb(91, 229, 64)'}>Yes</Box>
                        <Box w={'90%'} m={'10px auto'} fontWeight={'medium'} color={'grey'} border={'1px solid grey'} p={'10px'}>No</Box>
                        <Box w={'90%'} m={'10px auto'} fontWeight={'medium'} color={'grey'} border={'1px solid grey'} p={'10px'}>Not Now</Box>
                    </Box>

                    <Box w={['90%', '80%', '40%', '45%']} fontSize={['18px']} fontWeight={'medium'} color={'grey'} p={'10px'} m={'10px'}>
                        <Text>
                            Quiz Time are interactive platform where students participate to gain knowledge and excel beyond academics.
                        </Text>
                        {personal['token'] ?
                            <Button w={'200px'} bg={'orange'} color={'whiteAlpha.900'} mt={'15px'} onClick={() => navigate('Dashboard')}>Dashboard</Button>
                            :
                            <Login />
                        }
                    </Box>


                    {/* <Box w={'300px'} h={'300px'} color={'grey'} fontWeight={'bold'} fontSize={'14px'} m={'10px'} display={'flex'} justifyContent={'center'} alignItems={'center'} border={'1px solid orange'} _hover={{ boxShadow: 'red 0px 0px 30px', border: '1px solid red' }} transition={'0.5s ease'} borderRadius={'50%'} boxShadow={'orange 0px 0px 30px'}>
                        <Text >
                            Quiz Time are interactive platform where students participate to gain knowledge and excel beyond academics.
                        </Text>
                        <Button w={'200px'} bg={'orange'} color={'whiteAlpha.900'} mt={'15px'}>START</Button>
                    </Box> */}

                </Box>
            </Box>

            <Box border={'1px solid transparent'} borderRadius={'20px 20px 0 0'} bg={'linear-gradient(30deg, rgb(0, 7, 61), rgb(0, 10, 63), rgb(0, 13, 66), rgb(0, 16, 68), rgb(0, 19, 71), rgb(0, 22, 73), rgb(0, 25, 76), rgb(0, 28, 78), rgb(0, 31, 80), rgb(0, 34, 83), rgb(0, 37, 85), rgb(0, 40, 88), rgb(0, 43, 90), rgb(0, 46, 92), rgb(0, 49, 95), rgb(0, 52, 97), rgb(0, 55, 100), rgb(0, 58, 102), rgb(0, 61, 105), rgb(0, 64, 107))'}>

                <Grid w={'90%'} m={'1cm auto'} templateColumns={['repeat(2, 1fr)', 'repeat(3, 1fr)', 'repeat(4, 1fr)']} gap={['30px 20px']}>
                    {contect_Data && contect_Data?.map((ele, index) => (
                        <Box border={`3px solid ${ele.boxshadow}`} onClick={() => navigate(ele.url)} cursor={'pointer'} key={index} borderRadius={'20px'}>
                            <Box bg={''} color={ele.textcolor} m={'15px auto'} fontSize={'25px'} fontWeight={'medium'} display={'flex'} justifyContent={'center'} alignItems={'center'} border={`1px solid ${ele.boxshadow}`} borderRadius={'50%'} width={'130px'} height={'130px'} boxShadow={`${ele.boxshadow} 0px 0px 5px`}>
                                {ele.title}
                            </Box>
                            <Text borderRadius={'0 0 20px 20px'} bg={'#8080801F'} color={'white'} _hover={{ color: ele.textcolor }} transition={'0.4s ease'} fontWeight={'medium'} p={'10px'} textAlign={'center'}>{ele.name}</Text>

                        </Box>
                    ))}
                </Grid>

            </Box>
        </Box>
    )
}




